import styled from 'styled-components';

export const InputStyled = styled.input`
  border: 1px solid var(--purple);
  border-radius: 10px;
  width: 200px;
  padding-left: 20px;
  height: 40px;
  font-size: 22px;
`;
